import { lazy } from "react";

export const ProtectedRoute = lazy(() => import("./ProtectedRoute"));
